import { FC } from 'react';
import { isSrcSetSupported } from '../../utils/featureDetection';
import { getSrcsetString } from 'dibs-image-utils/exports/srcSet';

export const FetchPriorityValues = {
    HIGH: 'high',
    LOW: 'low',
    AUTO: 'auto',
} as const;

export type Props = {
    id?: string;
    isClient?: boolean;
    type?: string;
    widths?: number[];
    quality?: number;
    dataTn?: string;
    alt?: string;
    sizes?: string;
    className?: string;
    photo: {
        masterOrZoomPath: string | null;
        largePath: string | null;
    };
    fetchPriority?: (typeof FetchPriorityValues)[keyof typeof FetchPriorityValues];
};

type InnerProps = {
    src?: string;
    srcSet?: string;
    sizes?: string;
    fetchpriority?: (typeof FetchPriorityValues)[keyof typeof FetchPriorityValues];
};

export const ResponsiveImage: FC<Props> = props => {
    const { photo, isClient, dataTn, alt, sizes, widths, className, id, fetchPriority } = props;
    const { masterOrZoomPath, largePath } = photo;
    const innerProps: InnerProps = {
        src: undefined,
        sizes: undefined,
        srcSet: undefined,
    };
    const isValidFetchPriority = Object.values(FetchPriorityValues).some(
        val => fetchPriority === val
    );

    if (largePath) {
        innerProps.src = largePath;
    }

    if (masterOrZoomPath && sizes) {
        innerProps.sizes = sizes;
        innerProps.srcSet = getSrcsetString(masterOrZoomPath, widths);
    }

    if (fetchPriority && isValidFetchPriority) {
        innerProps.fetchpriority = fetchPriority;
    }

    /**
     * Safari has bug when loading dynamically injected img with srcset, need to remove src
     * so it doesn't load 2 images (1 from src and 1 from srcset)
     */
    if (isClient && isSrcSetSupported()) {
        innerProps.src = undefined;
    }

    return <img id={id} alt={alt || ''} data-tn={dataTn} className={className} {...innerProps} />;
};
